if (typeof window.Pmc == 'undefined') {
  window.Pmc = {};
}

Pmc.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Pmc.Status = {
  UNINITIALIZED: 'uninitialized',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected',
};

Pmc.AddressCoverage = {
  PREMIUM: 0,
  STANDARD: 1,
};

Pmc.formatAddress = function (address) {
  return [address.street?.replace(',', ''), address.streetNumber, address.city].filter(Boolean).join(', ');
};

Pmc.serializeError = function (value) {
  if (typeof value === 'object' && value !== null) {
    const simpleError = {};
    for (const property of Object.keys(value)) {
      if (typeof value[property] === 'string') {
        simpleError[property] = value[property];
      }
    }

    return simpleError;
  }

  return { message: String(value) };
};

Pmc.getUserAddress = function (user) {
  const { AddressCoverage } = Pmc;
  return user.addresses.find((address) => address.coverage === AddressCoverage.STANDARD && address.isActive);
};

Pmc.createStore = function () {
  if (Pmc.store) {
    return Pmc.store;
  }

  const { Status } = Pmc;

  const initialState = {
    settings: { status: Status.UNINITIALIZED },
    user: { status: Status.UNINITIALIZED },
  };

  function reducer(state = initialState, action) {
    switch (action.type) {
      case 'fetchSettings/pending': {
        const settings = { ...state.settings, status: Status.PENDING, requestId: action.meta.requestId };
        return { ...state, settings };
      }
      case 'fetchSettings/rejected': {
        if (state.settings.requestId !== action.meta.requestId) {
          return state;
        }
        const settings = { ...state.settings, status: Status.REJECTED, error: action.error, data: undefined };
        return { ...state, settings };
      }
      case 'fetchSettings/fulfilled': {
        if (state.settings.requestId !== action.meta.requestId) {
          return state;
        }
        const settings = { ...state.settings, status: Status.FULFILLED, data: action.payload, error: undefined };
        return { ...state, settings };
      }

      case 'fetchCurrentUser/pending': {
        const user = { ...state.user, status: Status.PENDING, requestId: action.meta.requestId };
        return { ...state, user };
      }
      case 'fetchCurrentUser/rejected': {
        if (state.user.requestId !== action.meta.requestId) {
          return state;
        }
        const user = { ...state.user, status: Status.REJECTED, error: action.error, data: undefined };
        return { ...state, user };
      }
      case 'fetchCurrentUser/fulfilled': {
        if (state.user.requestId !== action.meta.requestId) {
          return state;
        }
        const user = { ...state.user, status: Status.FULFILLED, data: action.payload, error: undefined };
        return { ...state, user };
      }

      default:
        return state;
    }
  }

  const store = Redux.createStore(reducer, Redux.applyMiddleware(ReduxThunk.thunk));
  Pmc.store = store;
  return store;
};
Pmc.createStore();

Pmc.fetchSettings = async function () {
  const { dispatch } = Pmc.store;

  const requestId = NanoId.nanoid();

  dispatch({ type: 'fetchSettings/pending', meta: { requestId } });

  try {
    const settings = await fetch(routes.settings_url, {
      headers: { 'X-Pmc-Host': location.host },
    }).then((response) => response.json());
    dispatch({ type: 'fetchSettings/fulfilled', payload: settings, meta: { requestId } });
    return settings;
  } catch (error) {
    dispatch({ type: 'fetchSettings/rejected', error: Pmc.serializeError(error), meta: { requestId } });
    throw error;
  }
};

Pmc.fetchCurrentUser = async function () {
  const { dispatch } = Pmc.store;

  const requestId = NanoId.nanoid();

  dispatch({ type: 'fetchCurrentUser/pending', meta: { requestId } });

  const cookies = Cookie.parse(document.cookie);
  const accessToken = cookies.pmc_access_token;

  try {
    const user = await fetch(routes.current_user_url, {
      headers: { Authorization: `Bearer ${accessToken}`, 'X-Pmc-Host': location.host },
    }).then((response) => response.json());
    dispatch({ type: 'fetchCurrentUser/fulfilled', payload: user, meta: { requestId } });
    console.log('user', user);
    return user;
  } catch (error) {
    dispatch({ type: 'fetchCurrentUser/rejected', error: Pmc.serializeError(error), meta: { requestId } });
    window.location = 'https://qurakare.com';
    throw error;
  }
};

Pmc.updateCartAttributes = async function (props) {
  const { host, user } = props;
  const address = Pmc.getUserAddress(user);
  const attributes = {
    host,
    user_id: user.id,
    user_email: user.email,
    user_first_name: user.firstName,
    user_last_name: user.lastname,
    user_address_street: address?.street,
    user_address_street_number: address?.streetNumber,
    user_address_city: address?.city,
    user_address_province: address?.province,
    user_address_country: 'IT',
    user_address_zip: address?.cap,
  };
  const cart = await fetch(routes.cart_update_url, { ...fetchConfig(), body: JSON.stringify({ attributes }) }).then(
    (response) => response.json()
  );
  return cart;
};
